<template>
  <svg
    width="51"
    height="51"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.5 44.4733C16.3409 44.4733 8.91691 37.0493 8.91691 27.8902C8.91691 18.7311 16.3409 11.2786 25.5 11.2786C34.6591 11.2786 42.0831 18.7026 42.0831 27.8618C42.0831 28.6582 42.0262 29.4262 41.9125 30.1658H46.6342C46.6911 29.5969 46.748 29.028 46.748 28.4306C46.8902 23.3675 45.212 18.4466 42.0547 14.4929L44.7285 11.8191C45.1836 11.364 45.1836 10.6244 44.7285 10.1693L43.0502 8.49109C42.5951 8.03597 41.8271 8.03597 41.372 8.49109L38.7551 11.2786C36.252 9.25909 33.3507 7.80842 30.2218 7.06886V4.16753C30.2218 2.85909 29.1694 1.80664 27.8609 1.80664H23.1391C21.8307 1.80664 20.7782 2.85909 20.7782 4.16753V7.06886C11.0502 9.28753 4.16669 17.9062 4.16669 27.8618C4.30891 39.3533 13.4111 48.74 24.8742 49.1951H25.4716C26.2111 49.1951 26.9222 49.1666 27.6334 49.0813V44.3026C26.9507 44.4164 26.2396 44.4733 25.5 44.4733Z"
      fill="white"
    />
    <path
      d="M24.5898 16.0284C23.9356 16.0284 23.3951 16.5689 23.3951 17.2231V29.0844C23.3951 29.7387 23.9356 30.2791 24.5898 30.2791H26.3818C27.036 30.2791 27.5765 29.7387 27.5765 29.0844V17.1947C27.5765 16.5404 27.036 16 26.3818 16H24.5898V16.0284Z"
      fill="white"
    />
    <path
      d="M43.3719 42.9293L35.5406 48.1793C34.7484 48.7105 33.6766 48.498 33.1469 47.7074C32.9562 47.423 32.8547 47.0887 32.8547 46.7465V36.2465C32.8547 35.2934 33.6281 34.5215 34.5797 34.5215C34.9219 34.5215 35.2562 34.623 35.5406 34.8137L43.3703 40.0637C44.1625 40.5949 44.3734 41.6668 43.8422 42.4574C43.7203 42.6434 43.5594 42.8043 43.3719 42.9293Z"
      fill="white"
    />
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'IconStartShift',
} as DefineComponent
</script>
